// extracted by mini-css-extract-plugin
export default {"container":"Quiz_container__kmFYD","containerQuiz":"Quiz_containerQuiz__NBm4K"};